import React, {Component} from 'react';
import axios from 'axios';
import moment from 'moment';

import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import EditableCell from './EditableCell';
import Config from '../../config';

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');

class AddOrderRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valid: false,
            regNr: "",
            serieNr: "",
            carModel: "-",
            wheeltype: "-",
            offRentDate: "-",
            lastOnRentDate: "-",
            id: "",
            switchFocus: false,
            order: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.createOrder = this.createOrder.bind(this);
        this.validateRegNo = this.validateRegNo.bind(this);
    }

    findWheel() {
        let wheelList = []
        let regNr = this.state.regNr.split(" ");
        let serieNr = this.state.serieNr.split(" ");

        for(const x in regNr) {
            wheelList.push({regNo: regNr[x], waggonNo: serieNr[x]})
        }
        
        const reserveOrder = {
            toLocationId: parseInt(Config.api.getWheelChangerId(), 10),
            wheels: wheelList
        };

        axios.post(Config.api.getDomain() + 'wheelOrder/reserve', reserveOrder, Config.api.getConfig())
            .then(res => {
                const reservedWheels = res.data.data.reservedWheels;
                reservedWheels.forEach((wheel) => {
                        if(regNr.length === 1) {
                            this.props.updateOrderList([...this.props.addedOrders, {
                                bilmodell: reservedWheels[0].wheelInfo.carModel,
                                hjulmodell: reservedWheels[0].wheelInfo.wheeltype.name,
                                offRentDate: reservedWheels[0].wheelInfo.offRentDateTime,
                                lastOnRentDate: reservedWheels[0].wheelInfo.offRentDateTime,
                                id: reservedWheels[0].wheelInfo.id,
                                serienr: reservedWheels[0].wheelInfo.waggonNo,
                                regnr: reservedWheels[0].wheelInfo.regNo,
                                valid: reservedWheels[0].success,
                                errorMsg: reservedWheels[0].success ? "" : reservedWheels[0].wheelInfo.regNo + " " + reservedWheels[0].message
                            }], true)
                            this.regNr.clear();
                            this.serieNr.clear();
                            this.regNr.input.focus();
                        } else {
                            this.props.updateOrderList(this.props.addedOrders.map((item) => {

                                const foundCorrectCar = reservedWheels.find((reservedWheel) => {
                                    return reservedWheel.wheelInfo.waggonNo === item.serienr && reservedWheel.wheelInfo.regNo === item.regnr
                                })
            
                                if(item.bilmodell) {
                                    return item;
                                } else {
                                    item.bilmodell = foundCorrectCar.wheelInfo.carModel;
                                    item.hjulmodell = foundCorrectCar.wheelInfo.wheeltype.name;
                                    item.offRentDate = foundCorrectCar.wheelInfo.offRentDateTime;
                                    item.lastOnRentDate = foundCorrectCar.wheelInfo.lastOnRentDate;
                                    item.id = foundCorrectCar.wheelInfo.id;
                                    item.valid = foundCorrectCar.success;
                                    item.errorMsg = foundCorrectCar.success ? "" : foundCorrectCar.wheelInfo.regNo + " " + foundCorrectCar.message
                                    return item;
                                }
                            }), true)
                            this.regNr.clear();
                            this.serieNr.clear();
                            this.regNr.input.focus();
                        }
                })
            })
            .catch(error => {
                this.props.showError(`Bilen du vill beställa hjul till finns inte i Wheel ITs databas`);
                this.setState({
                    carModel: '-',
                    wheeltype: '-',
                    offRentDate: '-',
                    lastOnRentDate: '-'
                })
            })
    }

    // Clears input fields and states
    clearInputs() {
        this.regNr.clear();
        this.serieNr.clear();
        this.setState({
            regNr: '',
            serieNr: '',
            carModel: '-',
            wheeltype: '-',
            offRentDate: '-',
            lastOnRentDate: '-',
            id: '',
            valid: false
        }, () => {
            this.regNr.input.focus()
        })
    }

    validateRegNo(...regNos) {

        const flatted = this.props.addedOrders.map(x => x.regnr)

        const newRegNumbers = []
        const existingRegNumbers = []
        regNos.forEach(r => {
            if (!flatted.includes(r)) {
                newRegNumbers.push(r)
            } else {
                existingRegNumbers.push(`${r}  togs bort, hjulhuset finns redan i listan`)
            }
        })

        if (existingRegNumbers.length > 0) {
            this.props.showError(existingRegNumbers)
        }
        return newRegNumbers
    }

    handleChange(event, eventName, eventValue) {
        let e = event
        if(!event) {
            e = {target: {name: eventName, value: eventValue}}
        }
        let value = e.target.value;
        const validRegNo = /^(?:[A-Z]{3}|\d{2})(?:\d{2})(?:[A-Z]{1}|\d{1})$/;
        if(e.target.name === "regNr") {
            value = value.toUpperCase();
            if (validRegNo.test(value)) {
                this.setState({[e.target.name]: value}, () => {
                    this.serieNr.input.focus()
                })
            } else {
                const regNos = value.split(' ')
                const result = this.validateRegNo(...regNos)
                const errorNos = regNos.filter(e => !validRegNo.test(e))
                if (errorNos.length > 0) {
                    //this.props.showError(`Felinmatning: ${errorNos}`)
                } else {
                    this.props.updateOrderList(result.map(e => ({
                        regnr: e,
                        serienr: '',
                        bilmodell: '',
                        hjulmodell: '',
                        offRentDate: ''
                    })), false)
                    this.setState({[e.target.name]: result.join(" ")}, () => {
                        this.serieNr.input.focus()
                    })
                }
            }
        }

        if (e.target.name === "serieNr" && value.length >= 5) {
            value = value.toUpperCase();

            const serieNos = value.split(' ')
    
            if (serieNos.length > 1) {
                this.props.updateOrderList(this.props.addedOrders.map((item) => {
                    if(item.serienr) {
                        return item;
                    } else {
                        item.serienr = serieNos.shift()
                        return item;
                    }
                }), true)
            }
            this.setState({[e.target.name]: value}, () => {
                if (this.state.regNr.length >= 6) {
                    this.findWheel()
                    this.regNr.clear();
                    this.serieNr.clear();
                    this.regNr.input.focus();
                } else {
                    this.setState({valid: false})
                    this.props.hideError()
                }
            })
        }
    }

    handleKeyPress(e) {
        if (e.key === 'Enter' && this.state.valid) {
            e.preventDefault()
            this.createOrder(e)
        }
    }

    handleBlur(e) {
        if (this.state.valid) {
            this.createOrder(e)
        }
    }

    createOrder(e) {
        const data = {
            wheelId: this.state.id,
            fromLocationId: 0,
            toLocationId: parseInt(Config.api.getWheelChangerId(), 10),
        }

        const apiCall = Config.api.getStationType() === 'Harbour' ? 'createHarbourOrder' : 'createStationOrder'

        axios.post(Config.api.getDomain() + 'wheelOrder/' + apiCall, data, Config.api.getConfig())
            .then(response => {
                this.props.updateOrders()
                this.clearInputs();
            })
            .catch(error => {
                console.log(error)
                let message = error.response.data.message
                this.props.showError(message)
                this.props.updateOrders()
            })
    }

    render() {
       const debounce = (name, value) => {
            const handleChange = this.handleChange
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.timer = setTimeout(() => {
                this.timer = null;
                handleChange(null, name, value)
              }, 1000);
        };    

        return (
            <tr
                className={this.state.valid ? 'add-row validAdd' : 'add-row'}
            >
                <EditableCell
                    disabled={this.props.disabled}
                    placeholder='Regnr'
                    handleRowAdd={(event) => this.handleRowAdd(event)}
                    name='regNr'
                    ref={regNr => this.regNr = regNr}
                    handleChange={(event) => this.handleChange(event)}
                    handleKeyPress={(event) => this.handleKeyPress(event)}
                    onBlur={(event) => this.handleBlur(event)}
                />
                <EditableCell
                    disabled={this.props.disabled}
                    placeholder='Serienr'
                    name='serieNr'
                    ref={serieNr => this.serieNr = serieNr}
                    handleChange={(e) => debounce(e.target.name, e.target.value)}
                    handleKeyPress={(event) => this.handleKeyPress(event)}
                    onBlur={(event) => this.handleBlur(event)}
                />
                <td className="carModel" ref={carModel => this.carModel = carModel} style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                    {this.state.carModel !== '' ? this.state.carModel : '-'}
                </td>
                <td className="wheeltype" ref={wheeltype => this.wheeltype = wheeltype} style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                    {this.state.wheeltype !== '-' ? this.state.wheeltype.name : '-'}
                </td>
                <td className="offRentDate" ref={offRentDate => this.offRentDate = offRentDate} style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                    {this.state.offRentDate !== '-' ? moment(this.state.offRentDate).format('YYYY-MM-DD - HH:mm') : '-'}
                </td>
                <td className="lastOnRentDate" ref={lastOnRentDate => this.lastOnRentDate = lastOnRentDate} style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                    {this.state.lastOnRentDate !== '-' ? moment(this.state.lastOnRentDate).format('YYYY-MM-DD') : '-'}
                </td>
                <td className='del-cell' style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                    <div className="del-btn"></div>
                </td>
            </tr>
        )
    }
}

export default AddOrderRow



// WEBPACK FOOTER //
// ./src/components/Orders/AddOrderRow.js